import { InputFile } from '../../models/jobModels/ModelsFileTypes';

export const prepareInputFileSimulation = (inputFiles: InputFile[], alias: string) => {
  const file = inputFiles.find((data) => data.alias === alias);
  return file ? { currentFile: { project: +file.project, name: file.fileid }, fileName: file.fileid } : undefined;
};
